import Ellipse from "../.././assets/images/Ellipse.png";
import TestimonialSection from "../common/TestimonialSection";
import ConnectWithUsForm from "../common/ConnectWithUsForm";

export default function TestimonialsContactSection({ data = null }) {
  return (
    <section className="bg-white md:pt-16  font-manrope">
      {/* Testimonials Section */}

      <TestimonialSection data={data} />

      {/* Contact Form Section */}
       <img src={Ellipse} alt="Ellipse" className="rotate-180"/>
      <ConnectWithUsForm />
    </section>
  );
}
